import styled from 'styled-components';
import { isMobile } from 'react-device-detect';

export const TableHeadRow = styled.tr`
  vertical-align: middle;
`;

export const TableRowHead = styled.thead`
  width: 100%;
  height: 35px;
  th {
    padding-top: ${() => (isMobile ? '10px' : '0')};
    padding-bottom: ${() => (isMobile ? '10px' : '0')};
  }
  background: ${(props) => props.theme.tableHeadColor};
`;

export const TableRowHeader = styled.th`
  padding-left: 5px;
  border-bottom: 3px solid ${(props) => props.theme.tableBorders};
  cursor: pointer;
`;

export const TableDropDownContainer = styled.div`
  background: ${(props) => props.theme.tableHeadColor};
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TableDropDownSelect = styled.select`
  background: ${(props) => props.theme.tableHeadColor};
  color: ${(props) => props.theme.tableHeadFont};
  width: 100%;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:focus-visible {
    border: none;
  }
`;

export const TableDropDownOptions = styled.option`
  background: ${(props) => props.theme.tableOptionsBackground};
  color: ${(props) => props.theme.tableOptionsColor};
  width: fit-content;
  &:focus-visible {
    border: none;
  }

  .status {
    width: 80px;
  }
`;
